import React, { useContext, useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Button, Card, Tabs, Tab } from '@material-ui/core'
import { useReportsQlikApi } from '../api/reportsQlik/reportsQlik.api'
import { QlikReport } from './QlikReport'
import { DashboardConfig } from './angular/DashboardConfig'
import { QlikUIContext } from '../QlikUIContext'
import { useQlik } from './RequireQlik'
import { QlikSyncButton } from './QlikSyncButton'
import { StreamReport } from './StreamReport'
import { useTranslation } from 'react-i18next'
import { useTheme, makeStyles } from '@material-ui/core'
import { stylesMui } from './styles/reports.styles'

export const Reports = () => {
  if (window.Zone !== undefined && window.Zone !== null) {
    window.location.reload()
  }

  const [t] = useTranslation(['qlik'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  const [streamReports, setStreamReports] = useState([])
  const [streamReportsInTab, setStreamReportsInTab] = useState(undefined)
  const [value, setValue] = React.useState('')
  const [isNewReport, setIsNewReport] = useState(false)
  const [viewReport, setViewReport] = useState(false)
  const [isEditingReport, setIsEditingReport] = useState(false)
  const [reportType, setReportType] = useState(1)
  const [report, setReport] = useState(undefined)
  const [streamId, setStreamId] = useState('')
  const [isAdmin, setIsAdmin] = useState(false)

  const context = useContext(QlikUIContext)
  const [qlikLoaded, qlik, qlikAsync] = useQlik()

  const apiReportsQlik = useReportsQlikApi()

  async function getStreamReports() {
    const reports = await apiReportsQlik.GetReports(
      context.userName,
      context.roles.split(','),
      1
    )
    const ambits = await apiReportsQlik.GetAmbits(1, context.roles.split(','))

    const streams = ambits
      .map((p) => p.Stream)
      .filter(
        (value, index, self) =>
          self.findIndex((p) => p.Id === value.Id) === index
      )

    setStreamReports(
      streams.map((stream, index) => {
        var streamAmbits = ambits.filter((p) => p.Stream.Id === stream.Id)

        let repos = []

        streamAmbits.forEach((ambit, i) => {
          reports
            .filter((p) => p.AmbitId === ambit.Id)
            .forEach((rep, j) => {
              repos.push({
                Description: ambit.Description,
                ThumbnailUrl: ambit.ThumbnailUrl,
                Report: rep
              })
            })
        })

        return {
          StreamId: stream.Id,
          StreamName: stream.Name,
          Reports: repos
        }
      })
    )
  }

  useEffect(() => {
    if (qlikLoaded) {
      const roles = context.roles.split(',')
      setIsAdmin(roles.includes('Administracion'))
      getStreamReports()
    }
  }, [qlikLoaded])

  useEffect(() => {
    if (streamReports != undefined && streamReports.length > 0) {
      let firstValue = streamReports[0].StreamName;
      setValue(firstValue)
      setStreamReportsInTab(
        streamReports.filter((item) => item.StreamName === firstValue)
      )
    }
  }, [streamReports])

  function reload() {
    window.location.reload(true)
  }

  const handleNewReport = (type, idStream) => {
    setReportType(type)
    setStreamId(idStream)
    setIsNewReport(true)
  }

  const handleViewReport = (type, repo) => {
    setReport(repo)
    setReportType(type)
    setViewReport(true)
  }

  const handleEndPersonalization = async () => {
    if (isNewReport) {
      reload()
    } else {
      // Tenemos que provocar una recarga de la página porque si no no funcionarían el resto de
      // aplicaciones angular (ListadoFacturas, ConfiguradorConceptos y ConfiguradorPlantillas).
      // La razón es que el ConfiguradorDashboard está hecho con angular 7 mientras que las otras están
      // con angular 4 y angular 5, y los cambios en angular 7 (concretamente en la versión de webpack que
      // utiliza) son incompatibles con las versiones 4 y 5. Por desgracia, esto provoca que al editar un
      // informe desde la visualización del mismo se redirija al inicio de Reports, es decir, el listado
      // de informes. La mejor solución para esto sería actualizar todas las aplicaciones de angular para
      // que utilicen la misma versión.

      reload()

      // await getStreamReports();
      // setIsEditingReport(false);
      // if (viewReport) {
      //     let idReport = report.Id;
      //     let repo = streamReports.find(p => p.Reports.some(q => q.Report.Id === idReport))
      //         .Reports.find(p => p.Report.Id === idReport);
      //     setReport(repo.Report);
      //     setReportType(repo.Report.Type);
      //     setReloadOnExit(true);
      // }
    }
  }

  const handleDeleteReport = async () => {
    await apiReportsQlik.DeleteReport(report.UserName, report.FileName, 1)
    reload()
  }

  const handleEditReport = (repo) => {
    setReport(repo)
    setIsEditingReport(true)
  }

  const handleEndVisualization = () => {
    setReport(undefined)
    setViewReport(false)
  }

  const onChangeTabHandler = (event, newValue) => {
    if (newValue !== undefined && streamReports.length !== 0) {
      setStreamReportsInTab(
        streamReports.filter((item) => item.StreamName === newValue)
      )
      setValue(newValue)
    }
  }

  const renderTabContent = () => {
    if (
      !viewReport &&
      streamReportsInTab &&
      streamReportsInTab.length > 0 &&
      value
    ) {
      return (
        <div
          key={value}
          role='tabpanel'
          id={`simple-tabpanel-${value}`}
          aria-labelledby={`simple-tab-${value}`}
        >
          {
            <Card elevation={1} className={classes.card}>
              <StreamReport
                streamRepo={streamReportsInTab[0]}
                onNewReport={handleNewReport}
                onViewReport={handleViewReport}
                onEditReport={handleEditReport}
              />
            </Card>
          }
        </div>
      )
    } else {
      return null
    }
  }

  return (
    <React.Fragment>
      <div className={classes.content}>
        <Grid container direction='row' className={classes.header}>
          {!viewReport && isAdmin && (
            <QlikSyncButton
              qlikAsync={qlikAsync}
              onEndSynchronization={reload}
            />
          )}

          {viewReport && (
            <Button
              onClick={handleEndVisualization}
              title={t('qlik:reports.btnBack')}
              variant='contained'
              color='primary'
            >
              {t('qlik:reports.btnBack')}
            </Button>
          )}
        </Grid>

        {!viewReport && streamReports && (
          <Tabs
            className={classes.tabsRoot}
            value={value}
            onChange={onChangeTabHandler}
            indicatorColor='primary'
            textColor='primary'
          >
            {streamReports.map((repo, index) => {
              return (
                <Tab
                  key={repo.StreamId}
                  label={repo.StreamName}
                  value={repo.StreamName}
                ></Tab>
              )
            })}
          </Tabs>
        )}
        {renderTabContent()}

        {viewReport && (
          <Card elevation={1} className={classes.cardContainer}>
            <QlikReport
              qlik={qlik}
              report={report}
              reportType={`${reportType}`}
              onEditReport={handleEditReport}
            ></QlikReport>
          </Card>
        )}
      </div>

      {isNewReport && (
        <DashboardConfig
          config={{
            reportType: `${reportType}`,
            activeReportName: '',
            report: '',
            editorMode: '0',
            streamId,
            ambitId: ''
          }}
          onEndPersonalization={handleEndPersonalization}
          onDeleteReport={handleDeleteReport}
        />
      )}

      {isEditingReport && (
        <DashboardConfig
          config={{
            reportType: `${report.Type}`,
            activeReportName: report.Id,
            report: { report },
            editorMode: '1',
            streamId: '',
            ambitId: report.AmbitId
          }}
          onEndPersonalization={handleEndPersonalization}
          onDeleteReport={handleDeleteReport}
        />
      )}
    </React.Fragment>
  )
}
